import http from './http';

/// MakinaFoto

export function getMakinaFotos(makinaId) {
    return http.get(`/makinafoto/makina/${makinaId}`);
}

export function upload(makina_id, file) {
    const data = new FormData();
    data.append('file', file);
    data.append('makina_id', makina_id);
    return http.post(`/makinafoto/upload`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

